module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11GFnV9/tc-custom/9781488068591.jpg?1708801963484",
      "alt": "This image is the cover for the book Confessions of an Italian Marriage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Confessions of an Italian Marriage\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("USA Today")]), _vm._v("–Bestselling Author: An estranged husband and wife rekindle their extraordinary passion in this emotional romance.")]), _c('br'), _c('br'), _c('i', [_vm._v("He’s back to reclaim her . . . but where has he been?")]), _c('br'), _c('br'), _vm._v("What do you do when your husband goes missing? Flush him out by pretending to marry again!"), _c('br'), _c('br'), _vm._v("Billionaire Giovanni’s dramatic return forces Freja to confront the deep hurt she felt at his desertion . . . and the sparks that continue to fly between them. Giovanni had to go into hiding to protect his new bride from the dangers of his secret life—a life he pursues despite his disability. But he’s shocked by how his mysterious past has affected Freja. Now he’ll have to let her in closer than he’s allowed anyone before if he’s to save the whirlwind marriage he’s suddenly so compelled to fight for . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dani Collins\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When Canadian Dani Collins found romance novels in high school she wondered how one trained for such an awesome job. She wrote for over two decades without publishing, but remained inspired by the romance message that if you hang in there you'll find a happy ending. In May of 2012, Harlequin Presents bought her manuscript in a two-book deal. She's since published more than forty books with Harlequin and is definitely living happily ever after.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0